import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withStyles, ExpansionPanel, ExpansionPanelDetails, ExpansionPanelSummary } from '@material-ui/core';
import { ExpandMore as ExpandMoreIcon } from '@material-ui/icons';
import { ApplianceIconComponent } from 'data/common/iconsvg';
import ProductModuleDetail from './ProductModuleDetail';

class DetailExpansionPanelRow extends PureComponent {
    static propTypes = {
        theme: PropTypes.object.isRequired,
        classes: PropTypes.object.isRequired,
        moduleKey: PropTypes.string.isRequired,
        expanded: PropTypes.string,
        handleChange: PropTypes.func.isRequired,
        line: PropTypes.object.isRequired,
        lineType: PropTypes.string.isRequired,
        lineLabel: PropTypes.string.isRequired,
        lineCode: PropTypes.string.isRequired,
        productKey: PropTypes.string.isRequired,
        productType: PropTypes.string
    };
    static defaultProps = {
        expanded: null,
        productType: 'fhe_product'
    };

    render() {
        const { classes, theme, moduleKey, expanded, handleChange, line, lineType, lineCode, lineLabel, productKey, productType } = this.props;
        return (
            <ExpansionPanel key={moduleKey} expanded={expanded === moduleKey}>
                <ExpansionPanelSummary
                    expandIcon={<ExpandMoreIcon />}
                    onClick={handleChange}
                    className={classes.panelSummary}
                    classes={{ content: classes.panelSummaryContent }}
                >
                    <ApplianceIconComponent productModule={line} color={theme.palette.primary.main} size={30} />
                    <span className={classes.accordionTitle}>
                        {lineCode} - {lineLabel}
                    </span>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    <ProductModuleDetail
                        expanded={expanded}
                        lineType={lineType}
                        productKey={productKey}
                        productModulekey={moduleKey}
                        productType={productType}
                    />
                </ExpansionPanelDetails>
            </ExpansionPanel>
        );
    }
}

const styles = theme => ({
    panelSummary: {
        padding: '4px 12px'
    },
    panelSummaryContent: {
        alignItems: 'center'
    },
    accordionTitle: {
        paddingLeft: 10,
        color: theme.palette.common.black
    }
});

export default withStyles(styles, { withTheme: true })(DetailExpansionPanelRow);



// WEBPACK FOOTER //
// ./environments/fhe/scenes/Products/components/ProductModule/DetailExpansionPanelRow.js